import { useState } from "react";
import { useTranslation } from "react-i18next";
import NavLink from "./NavLink";

export default function Navbar() {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16">
        <Link
          to="/"
          className={`font-serif font-bold text-2xl whitespace-nowrap transition-colors duration-300 ${
            scrolled ? "text-foreground-950" : "text-white"
          }`}
        >
          {t("common.siteName")}
        </Link>

        <div className="hidden md:flex items-center space-x-10">
          <NavLink to="/" scrolled={scrolled}>
            {t("common.nav.home")}
          </NavLink>
          <NavLink to="/category/wanghong-dagua" scrolled={scrolled}>
            {t("common.nav.category")}
          </NavLink>
          <NavLink to="/about" scrolled={scrolled}>
            {t("common.nav.aboutUs")}
          </NavLink>
        </div>

        <div className="hidden md:flex items-center space-x-4">
          <button
            className={`w-10 h-10 flex items-center justify-center rounded-full transition-colors duration-300 ${
              scrolled
                ? "text-foreground-700 hover:bg-background-200"
                : "text-white hover:bg-white/10"
            }`}
            aria-label={t("common.nav.search")}
          >
            <i className="ri-search-line text-lg"></i>
          </button>
          <button
            className={`whitespace-nowrap px-5 py-2 rounded-full border transition-all duration-300 text-sm font-medium ${
              scrolled
                ? "border-foreground-300 text-foreground-800 hover:bg-foreground-100"
                : "border-white/60 text-white hover:bg-white/10"
            }`}
          >
            {t("common.nav.login")}
          </button>
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-full ${
            scrolled ? "text-foreground-900" : "text-white"
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-6 py-4 space-y-3">
          <Link
            to="/"
            className="block text-foreground-900 py-2 font-medium"
            onClick={() => setMenuOpen(false)}
          >
            {t("common.nav.home")}
          </Link>
          <Link
            to="/category/wanghong-dagua"
            className="block text-foreground-700 py-2"
            onClick={() => setMenuOpen(false)}
          >
            {t("common.nav.category")}
          </Link>
          <Link
            to="/about"
            className="block text-foreground-700 py-2"
            onClick={() => setMenuOpen(false)}
          >
            {t("common.nav.aboutUs")}
          </Link>
          <div className="pt-2 flex space-x-3">
            <button className="whitespace-nowrap px-4 py-2 rounded-full border border-foreground-300 text-foreground-800 text-sm">
              {t("common.nav.search")}
            </button>
            <button className="whitespace-nowrap px-4 py-2 rounded-full border border-foreground-300 text-foreground-800 text-sm">
              {t("common.nav.login")}
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}